import Vue from 'vue'
import Router from 'vue-router'
import { checkClientTermsAcceptance } from '@/app/authentication/ClientTermsServices'
import ClientTermsModel from '@/app/authentication/models/ClientTermsModel'
import { trackModuleView } from '@/app/shared/analytics/moduleTracking'

// Containers
import Full from '@/containers/Full'

// Views
// Legacy dashboard kept for reference but route now uses the new module
// import Dashboard from '@/expertoRetail/views/Dashboard'

import Mobile from '@/expertoRetail/views/Mobile'
import MobileStoreDetail from '@/expertoRetail/atoms/ExpertoRetailMobileStoreDetail'
import MobileProductList from '@/expertoRetail/atoms/ExpertoRetailMobileProductList'
import MobileWmProductList from '@/expertoRetail/atoms/ExpertoRetailMobileWmProductList'
import MobileNewStockProductList from '@/expertoRetail/atoms/ExpertoRetailMobileNewStockProductList'

import NewsFeedRoutes from '@/app/news_feed/Routes'

import GeneralKeyKpiAnalysis from '../expertoRetail/views/GeneralKeyKpiAnalysis'

//Rutas para la nueva arquitectura!
import MassiveFileDownloadRoutes from '@/app/massive_download/MassiveDownloadRoutes'
import SalesAnalysisRoutes from '@/app/sales_analysis/Routes'
import StoreGrowthRoutes from '@/app/store_growth/Routes'
import StockBreakRoutes from '@/app/stock_break/Routes'
import weeklySalesRoutes from '@/app/weekly_sales/Routes'
import adminRoutes from '@/app/admin/Routes'
import authenticationRoutes from '@/app/authentication/Routes'
import monthlySalesRoutes from '@/app/monthly_sales/Routes'
import dailySalesRoutes from '@/app/daily_sales/Routes'
import worksPaceRoutes from '@/app/workspaces/Routes'
import activationsRoutes from '@/app/activations/Routes'
import purchaseOrders from '@/app/purchase_orders/Routes'
import productFollowUp from '@/app/product_follow_up/Routes'
import merchants from '@/app/merchants/Routes'
import sellInProposal from '@/app/sell_in_proposal/Routes'
import selloutDashboard from '@/app/sellout_dashboard/Routes'
import productMaster from '@/app/product_master/Routes'
import userApiRoutes from '@/app/user_api/Routes'
import priceCampaignRoutes from '@/app/price_campaign/Routes'
import physicalStockCountsRoutes from '@/app/physical_stock_counts/Routes'
import routePlanningRoutes from '@/app/route_planning/Routes'

// Views - Pages
import Page404 from '@/views/pages/Page404'
import UnderMaintenance from '@/views/pages/UnderMaintenance'

import store from '@/store/index'

Vue.use(Router)

let termsCheckedThisSession = false

const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    ...authenticationRoutes,
    {
      path: '/',
      redirect: '/login',
      name: 'Home',
      component: Full,
      props: true,
      children: [
        {
          path: 'dashboard',
          component: () => import('@/app/dashboard/TheDashboard'),
          children: [
            {
              path: '',
              name: 'Dashboard',
              component: () => import('@/app/dashboard/views/DashboardMain')
            },
            {
              path: 'preset/:presetIndex',
              name: 'DashboardGrid',
              component: () => import('@/app/dashboard/views/DashboardGrid'),
              props: true
            }
          ]
        },
        {
          path: 'mobile',
          name: 'Mobile',
          component: Mobile,
          props: true
        },
        {
          path: 'store_detail',
          name: 'StoreDetail',
          component: MobileStoreDetail,
          props: true
        },
        {
          path: 'product_detail',
          name: 'ProductDetail',
          component: MobileProductList,
          props: true
        },
        {
          path: 'wm_product_List',
          name: 'WmProductList',
          component: MobileWmProductList,
          props: true
        },
        {
          path: 'new_stock_product_list',
          name: 'NewStockProductList',
          component: MobileNewStockProductList,
          props: true
        },
        ...NewsFeedRoutes,
        {
          path: 'general_key_kpi_analysis',
          name: 'GeneralKeyKpiAnalysis',
          component: GeneralKeyKpiAnalysis,
          props: true
        },
        ...MassiveFileDownloadRoutes,
        ...SalesAnalysisRoutes,
        ...StoreGrowthRoutes,
        ...StockBreakRoutes,
        ...weeklySalesRoutes,
        ...adminRoutes,
        ...monthlySalesRoutes,
        ...dailySalesRoutes,
        ...worksPaceRoutes,
        ...activationsRoutes,
        ...purchaseOrders,
        ...productFollowUp,
        ...merchants,
        ...sellInProposal,
        ...selloutDashboard,
        ...productMaster,
        ...userApiRoutes,
        ...priceCampaignRoutes,
        ...physicalStockCountsRoutes,
        ...routePlanningRoutes
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      meta: { noNeedDefaultData: true },
      component: {
        render (c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: 'under-maintenance',
          name: 'UnderMaintenance',
          component: UnderMaintenance
        }
      ]
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  // Check if user needs to be redirected to login
  if (!to.matched.some(record => record.meta.noNeedDefaultData) && !store.getters.isConfigLoaded && !store.getters.isLoggedIn) {
    next({ name: 'Login' })
    return
  }

  // Skip terms check if already on terms page or login page
  if (to.name === 'clientTermsAcceptance' || to.name === 'login' || to.name === 'Login') {
    next()
    return
  }

  // Check terms with backend if logged in (once per session)
  if (store.getters.isLoggedIn && store.getters.isConfigLoaded && !termsCheckedThisSession) {
    try {
      const termsData = await checkClientTermsAcceptance()
      const termsModel = new ClientTermsModel(termsData)
      termsCheckedThisSession = true

      if (termsModel.needsAcceptance) {
        next({ name: 'clientTermsAcceptance' })
        return
      }
    } catch (error) {
      console.error(error)
    }
  }

  next()
})

router.afterEach((to, from) => {
  trackModuleView(to, from)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js